// mqtt.service.ts
import { Injectable } from '@angular/core';
import * as mqtt from 'mqtt';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import {CpcWebApiService} from '../cpc-web-api.service';

@Injectable()
export class MqttService {
  public client: mqtt.MqttClient;
  public messages: Subject<any> = new Subject<any>();
  private mqttUrl: '';
  private mqttUsername: '';
  private mqttPassword: '';

  constructor( private webapi: CpcWebApiService) {
    // 取得MQTT配置
    const mqtt = window.sessionStorage.getItem('cpcmqtt');
    if (mqtt) {
      const mqttObj = JSON.parse(mqtt);
      this.mqttUrl = mqttObj.mqttUrl;
      this.mqttUsername = mqttObj.mqttUsername;
      this.mqttPassword = mqttObj.mqttPassword
    }
    // 连接MQTT服务器
    this.connect();
  }

  public connect() {
    // 替换为MQTT 服务器地址
    // 'ws://120.24.200.32:8086/mqtt'
    if (this.mqttUrl && this.mqttUsername && this.mqttPassword) {
      const host = this.mqttUrl;
      // 刷新会这样 直接从sessionStorage中取
      const strSysInfo = window.sessionStorage.getItem('sysInfo');
      const sysInfo = JSON.parse(strSysInfo);
      const topic = sysInfo.webapi.loginGUId;
      // 通知主题：按userid订阅，用于接收系统通知推送
      const notifyTopic = 'notify_' + sysInfo.userInfo.userId;
      const options = {
        topic: topic,
        clientId: topic,
        username: this.mqttUsername, // 'd8f93ecb26d7181e'
        password: this.mqttPassword, // 'BI9A1euxNFL9BguFwXb9BQYMOxMI1gC9BnitGOphL6S57GO',
        clean: false,  // 保留会话
      };
      this.client = mqtt.connect(host, options);

      this.client.on('connect', () => {
        console.log('MQTT connection established');
        // 订阅主题 this.webapi.getLoginGUId() 为当前登录用户的GUID 用于接收消息 一般为用户的GUID
        // qos: 1 保证消息到达一次
        this.client.subscribe(topic, { qos: 1 }, (err, granted) => {
          if (err) {
            console.error('MQTT subscription error:', err);
          } else {
            console.log('MQTT subscription granted:', granted);
          }
        });
        // 订阅通知主题（按userid）
        this.client.subscribe(notifyTopic, { qos: 1 }, (err, granted) => {
          if (err) {
            console.error('MQTT notify subscription error:', err);
          } else {
            console.log('MQTT notify subscription granted:', granted);
          }
        });
      });

      this.client.on('message', (topic, message) => {
        this.messages.next({ topic, message: message.toString() });
      });

      this.client.on('error', (error) => {
        console.error('MQTT Error:', error);
      });

      this.client.on('close', () => {
        console.log('MQTT connection closed');
      });
    } else {
      console.error('MQTT连接失败. 缺少必要的配置数据=》检查系统参数 ：mqttUrl, mqttUsername, mqttPassword');
    }
  }
  public publish(topic: string, message: string) {
    if (this.client.connected) {
      this.client.publish(topic, message);
    } else {
      console.error('MQTT client is not connected. Message could not be published.');
    }
  }
  // 断开连接
  destroy() {
    if (this.client) {
      // 断开连接
      this.client.end(false, () => {
        console.log('MQTT client disconnected');
        // 删除客户端引用
        this.client = null;
        // 清理 session storage
        window.sessionStorage.removeItem('cpcmqtt');

        console.log('MQTT client destroyed successfully');
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/home-page/mqtt.service.ts